import { Component, Input, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { map } from 'rxjs';
import {
  Filters,
  FnCaricamentoDati,
  SortBy,
} from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  BottoniListaEvent,
  Colonna,
  Filtri,
  ListaTabellareComponent,
} from 'src/app/components/lista-tabellare/lista-tabellare.component';
import { DialogCreaAziendaComponent } from 'src/app/page/aziende/dialog/dialog-crea-azienda/dialog-crea-azienda.component';
import { DialogVisUtenteComponent } from 'src/app/page/aziende/dialog/dialog-vis-utente/dialog-vis-utente.component';
import { Azienda, AziendaService } from 'src/app/services/azienda/azienda.service';
import { JsonFileService } from 'src/app/services/json-file/json-file.service';
import { LicenzeService } from 'src/app/services/licenze/licenze.service';
import { Utente, UtenteService } from 'src/app/services/utente/utente.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { SpinnerOverlayComponent } from '../spinner-overlay/spinner-overlay.component';

@Component({
  selector: 'app-lista-aziende',
  templateUrl: './lista-aziende.component.html',
  styleUrls: ['./lista-aziende.component.scss'],
  standalone: false,
})
export class ListaAziendeComponent {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  public isPermessoSoloRead: boolean =
    !this.utenteService.isPermessoAttivo('EDIT_AZIENDA') &&
    !this.utenteService.isPermessoAttivo('CREATE_AZIENDA');

  private _id_azienda: string[] | undefined = undefined;
  private _utente: Utente | undefined = undefined;

  @Input()
  get id_azienda() {
    return this._id_azienda;
  }

  set id_azienda(id_azienda: string[] | undefined) {
    this._id_azienda = id_azienda || undefined;
  }
  @Input()
  get utente() {
    return this._utente;
  }

  set utente(id_utente: Utente | undefined) {
    this._utente = id_utente || undefined;
  }
  @ViewChild('tabella') tabella!: ListaTabellareComponent;

  public filtri: Filtri[] = [
    {
      titolo: 'Nome Impresa',
      forControlName: 'ragioneSociale',
      input: 'text',
    },
    {
      titolo: 'P.IVA',
      forControlName: 'piva',
      input: 'text',
    },
    {
      titolo: 'Codice Ateco',
      forControlName: 'codiciAteco',
      input: 'multiple-option-chip',
      riempi: true,
      larghezza: 3,
      fnDatiOption: (ricerca: string | undefined, ids: any[] | undefined) =>
        this.jsonFileService.getAtecoFiltrato(ricerca, ids).pipe(
          map(
            (ateco: any) =>
              ateco.map((atec: any) => {
                return {
                  id: atec._id,
                  descrizione: atec._id + ' - ' + atec.desc,
                };
              }) ?? [],
          ),
        ),
      idValueOption: 'id',
      descValueOption: 'descrizione',
      numeroRecOptions: 10,
    },

    {
      titolo: 'Codice Nace',
      forControlName: 'codiciNace',
      input: 'multiple-option-chip',
      riempi: true,
      larghezza: 3,
      fnDatiOption: (ricerca: string | undefined, ids: any[] | undefined) =>
        this.jsonFileService.getNaceFiltrato(ricerca, ids).pipe(
          map(
            (nace: any) =>
              nace.map((nac: any) => {
                return {
                  id: nac._id,
                  descrizione: nac._id + ' - ' + nac.desc,
                };
              }) ?? [],
          ),
        ),
      idValueOption: 'id',
      descValueOption: 'descrizione',
      numeroRecOptions: 10,
    },

    {
      titolo: 'Informazioni Azienda',
      input: 'separatore',
      larghezza: 3,
      riempi: true,
    },
    {
      titolo: 'Indirizzo',
      forControlName: 'indirizzo',
      input: 'text',
    },
    {
      titolo: 'Regione',
      forControlName: 'regione',
      input: 'text',
    },
    {
      titolo: 'Comune',
      forControlName: 'comune',
      input: 'text',
    },
    {
      titolo: 'Provincia',
      forControlName: 'provincia',
      input: 'text',
    },
    {
      titolo: 'Descrizione',
      forControlName: 'descrizione',
      input: 'text',
      larghezza: 2,
    },
  ];

  public colonne: { [key: string]: Colonna } = {
    ragioneSociale: {
      title: 'Ragione Sociale',
      value: 'ragioneSociale',
      sortable: true,
    },
    /*  utenti: {
       title: 'Utenti',
       value: (record: any) => (record?.idAziende?.length || 0),
     }, */

    codiciAteco: {
      title: 'Codici Ateco',
      value: (record: any) => {
        const codici = record?.codiciAteco;
        // Visualizzo al massimo 4 codici separati da ' - ', se ci sono più di 5 codici aggiungo '...'
        if (Array.isArray(codici) && codici.length > 0) {
          const visualizzati = codici.slice(0, 4).join(' - ');
          return codici.length > 5 ? `${visualizzati}...` : visualizzati;
        }

        return '';
      },
      sortable: true,
    },

    piva: {
      title: 'Partita Iva',
      value: 'piva',
      sortable: true,
    },
    tipoInstallazione: {
      title: 'Tipo Installazione',
      value: (record: any) =>
        record.tipoInstallazione === 'SOSTENIBILE_CLOUD' ? 'Sostenibile Cloud' : 'Sostenibile GO',
      sortable: true,
    },

    modifica: {
      type: 'button',
      buttonIcon: this.isPermessoSoloRead ? 'visibility' : 'edit',
      title: this.isPermessoSoloRead ? 'Visualizza' : 'Modifica',
      buttonId: 'modifica',
      buttonMostraSempre: true,
      sortable: false,
    },

    utentiAssoc: {
      type: 'button',
      buttonIcon: 'person',
      title: 'Utenti',
      buttonId: 'utentiAssoc',
      buttonMostraSempre: true,
      sortable: false,
      nascondiButton: this.aziendaService.getNrChiamataDialogAzd() >= 1,
    },
    /* duplica: {
      type: 'button',
      buttonIcon: 'content_copy',
      title: 'Duplica',
      buttonId: 'duplica',
    }, */
    elimina: {
      type: 'button',
      buttonIcon: 'delete',
      title: 'Elimina',
      buttonId: 'elimina',
      sortable: false,
      nascondiButton: !this.utenteService.isPermessoAttivo('DELETE_AZIENDA'),
      buttonMostraSempre: false,
    },
  };

  constructor(
    public dialog: MatDialog,
    private readonly aziendaService: AziendaService,
    private readonly utilityService: UtilityService,
    public utenteService: UtenteService,
    public licenzeService: LicenzeService,
    private readonly jsonFileService: JsonFileService,
  ) {}
  ngAfterViewInit(): void {}

  ngOnInit(): void {
    /**
     * Metodo che mi riempie un array dei codici ateco.
     * E' stato inserito in questo componente poichè nella creazione dell'azienda
     * risultava abbastanza lento.
     *
     */
    this.aziendaService.setCodiciAteco();
    this.aziendaService.setCodiciNace();
    this.aziendaService.setCodiciPaesi();
  }

  /**
   * Metodo di modifica o creazione nuova bilancio
   * @param record
   */
  crea(record?: any) {
    const idUtente = this.utente?.id ? this.utente?.id : this.utenteService?.infoUtente?.utente?.id;
    const ruoloUtente = this._utente?.ruolo?.roleName
      ? this._utente?.ruolo?.roleName
      : this.utenteService?.infoUtente?.utente?.ruolo?.roleName;

    if (!record && idUtente && ruoloUtente !== 'configuratore') {
      let obsGetLicense: any;

      obsGetLicense = this.licenzeService.getUserHasLicenseIdUtente(idUtente, 'Azienda');

      this.spinnerOver.show();

      obsGetLicense.subscribe({
        next: () => {
          this.spinnerOver.hide();
          this.apriDialogCreaAzienda(record);
        },
        error: (err: any) => {
          this.spinnerOver.hide();

          this.utilityService.openDialog({
            titolo: 'Attenzione',
            descrizione: err?.error?.message,
            bottoni: [{ nome_btn: 'Ok' }],
          });
        },
      });
    } else {
      this.apriDialogCreaAzienda(record);
    }
  }

  /**
   * Apertura dialog filtri passati da l'esterno
   */
  apriDialogCreaAzienda(recordAzienda?: Azienda) {
    const _utente = this.utenteService.infoUtente?.utente;
    const ruoloUtente = this.utenteService.infoUtente?.utente.ruolo.roleName;
    let utente: any;
    if (!this.utente && ruoloUtente !== 'configuratore' && _utente) {
      utente = _utente;
    } else {
      utente = this.utente;
    }

    const dialogCreaAzienda = this.dialog.open(DialogCreaAziendaComponent, {
      data: {
        azienda: recordAzienda,
        utente: utente,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '80%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogCreaAzienda.afterClosed().subscribe((result) => {
      if (result && !this.id_azienda?.includes(result)) {
        this.id_azienda?.push(result);
        this.utenteService.aggiornaInfoUtente().subscribe();
      }

      this.tabella.caricaDati();
    });
  }

  public fnCaricamentoDati: FnCaricamentoDati = (
    page: number,
    pageSize: number,
    ricerca?: string,
    filters?: Filters[],
    sortBy?: SortBy[],
  ) => {
    const aziendaSortBy: SortBy = {
      chiave: 'ragioneSociale',
      sort: 'asc',
    };

    let actualSortBy: SortBy[] = [];

    if (sortBy) {
      // Ordinamento ricevuto, si controlla se presente un ordinamento per ragioneSociale
      const ordinatoPerRagSoc = sortBy.find((sort) => sort.chiave === 'ragioneSociale')
        ? true
        : false;

      if (ordinatoPerRagSoc) {
        // C'è già un ordinamento per ragioneSociale, si lascia invariato
        actualSortBy = sortBy;
      } else {
        // Non c'è un ordinamento per ragioneSociale, si accoda
        actualSortBy = sortBy?.concat(aziendaSortBy);
      }
    } else {
      // Nessun ordinamento ricevuto, si ordina per ragioneSociale
      actualSortBy = [aziendaSortBy];
    }

    if (this.id_azienda) {
      return this.aziendaService.getAziendeByIdAzienda(
        this.id_azienda,
        page,
        pageSize,
        ricerca,
        filters,
        actualSortBy,
      );
    } else {
      return this.aziendaService.getAziende(page, pageSize, ricerca, filters, actualSortBy);
    }
  };

  public bottoniListaClick(event: BottoniListaEvent) {
    switch (event.id) {
      case 'modifica':
      case 'visualizza':
        this.crea(event.data);
        break;
      case 'elimina':
        this._eliminaAzienda(event.data.id);
        break;
      case 'duplica':
        this._duplicaAzienda();
        break;
      case 'utentiAssoc':
        this._utentiAssoc(event.data);
        break;
      default:
        console.warn('ATTENZIONE: bottone ' + event.id + ' non riconosciuto');
    }
  }
  /**
   * Funzione per eliminare una riga da una lista tabellare
   * @param idRiga id della riga da eliminare
   */
  private _eliminaAzienda(idRiga: any) {
    this.utilityService.openDialog({
      descrizione: "Confermi di eliminare l'Azienda?",
      bottoni: [
        {
          nome_btn: 'NO',
          background_color: 'var(--mat-color-accent)',
        },
        {
          nome_btn: 'SI',
          background_color: 'var(--mat-color-primary)',
          handler: () => {
            this.spinnerOver.show();
            this.aziendaService.deleteAzienda(idRiga).subscribe({
              next: (result: any) => {
                this.utenteService.aggiornaInfoUtente().subscribe();
                this.tabella.caricaDati();
                this.spinnerOver.hide();
              },
              error: (err: any) => {
                this.spinnerOver.hide();
                this.utilityService.openDialog({
                  titolo: 'Attenzione',
                  descrizione: err.error.message,
                  bottoni: [
                    {
                      nome_btn: 'Chiudi',
                      handler: () => {
                        this.tabella.caricaDati();
                      },
                    },
                  ],
                });
              },
            });
          },
        },
      ],
    });
  }
  /**
   * Metodo per la duplicazione di un Azienda
   */
  public _duplicaAzienda() {
    this.utilityService.openDialog({
      titolo: 'Attenzione',
      descrizione: 'Da implementare la duplicazione ',
      bottoni: [
        {
          nome_btn: 'Chiudi',
          handler: () => {
            this.utilityService.closeDialog();
          },
        },
      ],
    });
  }
  public _utentiAssoc(azienda: Azienda) {
    const dialogCreaUtente = this.dialog.open(DialogVisUtenteComponent, {
      data: {
        idAzienda: azienda.id,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '80%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogCreaUtente.afterClosed().subscribe((result) => {
      this.aziendaService.setNrChiamataDialogAzd(0);
      this.utenteService.setNrChiamataDialogUsr(0);

      this.tabella.caricaDati();
    });
  }

  /**
   * controllo permessi per la visualizzazione del bottone nuova azienda
   * se this.utenteService.infoUtente?.nrMaxAziende === null vuoldire infinite
   * L'utente potrà crare un azienda solamente quando il numero delle aziende assegnate
   * sarà < di nrMaxAziende
   * @returns
   */
  isCreaAzienda(): boolean {
    const aziendeUtente = this.utenteService.infoUtente?.utente?.idAziende ?? [];

    return this.utenteService.isPermessoAttivo('CREATE_AZIENDA');
  }

  public isCollaboratoreOrReadOnly(): boolean {
    const ruoloLogin = this.utenteService?.infoUtente?.utente?.ruolo?.roleName;

    return !!(
      ruoloLogin &&
      ['collaboratore', 'utente_read_only', 'utente_read_only_go'].includes(ruoloLogin)
    );
  }
}
